import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { SPColor } from "../../constants/color";
import { SelectItem } from "../../types/global";
import { SchoolLeader } from "../../types/record";
import Loading from "../Loading/Loading";
import SPSelect from "../SPSelect/SPSelect";
import LeaderBoard from "./LeaderBoard";

type GradeLeaderProp = {
  gradeList: SelectItem[];
};

export default function GradeLeader({ gradeList }: GradeLeaderProp) {
  const [list, setList] = useState<SchoolLeader[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [grade, setGrade] = useState<number | null>(null);

  useEffect(() => {
    if (grade) {
      setLoading(true);
      fetch(`${process.env.REACT_APP_API_URL}/api/school-leader/${grade}`)
        .then((response) => response.json())
        .then((data) => {
          const list = JSON.parse(data.data);
          setList(
            list.sort((a: SchoolLeader, b: SchoolLeader) =>
              a.place > b.place ? 1 : -1
            )
          );
          setLoading(false);
        });
    } else {
      setList([]);
    }
  }, [grade]);

  if (loading) {
    return <Loading />;
  }

  return (
    <Box sx={{ textAlign: "center", maxWidth: "md", margin: "auto" }}>
      <Box sx={{ marginTop: 1, width: "100%" }}>
        <SPSelect
          items={gradeList}
          onChange={(e: string | number) => setGrade(+e)}
          defaultValue={grade || ""}
          bgColor={SPColor.WHITE}
          sx={{
            // borderColor: "black",
            minWidth: { xl: "150px", xs: "25%" },
            "& .MuiOutlinedInput-notchedOutline, & .MuiSelect-outlined, & .MuiSelect-select":
              {
                padding: "4px 28px 4px 16px",
                borderColor: SPColor.GREEN + " !important",
                borderWidth: "2px !important",
                border: "solid",
              },
          }}
          placeholder="בחר את סוג התחרות"
          name={"grade"}
        />
      </Box>
      <Box>
        {list.map((item: SchoolLeader) => (
          <LeaderBoard item={item} key={item.id} type="grade" />
        ))}
      </Box>
      {!grade && (
        <Box sx={{ direction: "RTL", marginTop: 3, textAlign: "justify" }}>
          <Typography>
			במסגרת פרויקט ״בית ספר טהא חוסים סכנין מדבר אנגלית״ מתקיימת תחרות של אנגלית דבורה בין כיתות. מטרת התחרות היא לעודד תרגול דיבור באנגלית בעזרת סימולטור השיחה,להגביר את המודעות וחשיבות הנושא ולעודד עזרה הדדית בין התלמידים. הציון הכיתתי משקף את כמות ההשקעה והתרגול של כל תלמידי הכיתה.
          </Typography>

          <Typography marginTop={3}>
			התחרות מבוצעת בין כיתות באותה שכבת גיל (לדוגמא כיתה משכבה ד מתמודדת מול כיתות ד אחרות בבית הספר.
          </Typography>

          <Typography marginTop={3}>
            <strong>חישוב הציון הכיתתי </strong> 
			וכיצד ניתן לשפר את הציון הכיתתי: כאשר התלמידים מתרגלים דיבור בסימולטור הם מקבלים כוכבים על כל משפט שתורגל באנגלית דבורה (שלושה כוכבים לביצוע מצוין, שניים לביצוע טוב ואחד לביצוע שאפשר לשפר). הציון כיתתי מהווה את מספר הכוכבים שצברה הכיתה. ככל שהתלמידים יתרגלו יותר דיבור באנגלית ויצברו יותר כוכבים – יעלו את הציון הכיתתי. גם תלמידים שמקבלים כוכב אחד על משפט יכולים להעלות את הציון הכיתתי על ידי תרגול רב יותר (וכך גם ישפרו את רמת האנגלית הדבורה שלהם). יש חשיבות רבה לכך שכל התלמידים בכיתה יתרגלו.
          </Typography>

          <Typography marginTop={3}>תרגול מהנה ומועיל ובהצלחה לכולם.</Typography>
        </Box>
      )}
    </Box>
  );
}
